<template>
  <mould-form />
</template>

<script>
import MouldForm from './components/MouldForm'

export default {
  name: 'PrintMouldEdit',
  components: { MouldForm }
}
</script>
